<div class="sera__line__chart__container">
    <label class="sera__line__chart__y_label">{{ yAxisLabel | translate }}</label>
    <p-chart
        type="line"
        [data]="chartData"
        [options]="LINE_CHART_OPTIONS" />
</div>
<label class="sera__line__chart__x_label">{{ xAxisLabel | translate }}</label>
